export const GET_WEIGHT_DISCREPANCY_AGGREGATE_SUCCESS = "GET_WEIGHT_DISCREPANCY_AGGREGATE_SUCCESS";
export const GET_WEIGHT_DISCREPANCY_AGGREGATE_REQUEST = "GET_WEIGHT_DISCREPANCY_AGGREGATE_REQUEST";
export const GET_WEIGHT_DISCREPANCY_AGGREGATE_FAILURE = "GET_WEIGHT_DISCREPANCY_AGGREGATE_FAILURE";
export const GET_WEIGHT_DISCREPANCY_AGGREGATE_RESET = "GET_WEIGHT_DISCREPANCY_AGGREGATE_RESET";
export const getWeightDiscrepancyAggregateSuccess = (payload) => ({
    type: GET_WEIGHT_DISCREPANCY_AGGREGATE_SUCCESS,
    payload,
});
export const getWeightDiscrepancyAggregateRequest = (payload) => ({
    type: GET_WEIGHT_DISCREPANCY_AGGREGATE_REQUEST,
    payload,
});
export const getWeightDiscrepancyAggregateFailure = (payload) => ({
    type: GET_WEIGHT_DISCREPANCY_AGGREGATE_FAILURE,
    payload,
});
export const getWeightDiscrepancyAggregateReset = () => ({
    type: GET_WEIGHT_DISCREPANCY_AGGREGATE_RESET,
});
